/**
 * 老挝语
 */
export default {
  name: 'lo',
  el: {
    colorpicker: { confirm: 'ຕົກລົງ', clear: 'ລ້າງ' },
    datepicker: {
      now: 'ໃນປີນີ້',
      today: 'ມື້ນີ້',
      cancel: 'ຍົກເລີກ',
      clear: 'ລ້າງ',
      confirm: 'ຕົກລົງ',
      selectDate: 'ເລືອກວັນທີ',
      selectTime: 'ເລືອກເວລາ',
      startDate: 'ວັນເລີ່ມຕົ້ນ',
      startTime: 'ເວລາເລີ່ມຕົ້ນ',
      endDate: 'ວັນສິ້ນສຸດ',
      endTime: 'ເວລາສິ້ນສຸດ',
      prevYear: 'ປີກາຍຫຍັງ',
      nextYear: 'ປີໜ້າຫຍັງ',
      prevMonth: 'ເດືອນກ່ອນ',
      nextMonth: 'ເດືອນຕໍ່ໄປ',
      year: 'ປີ',
      month1: 'ເດືອນ 1',
      month2: 'ເດືອນ 2',
      month3: 'ເດືອນ 3',
      month4: 'ເດືອນ 4',
      month5: 'ເດືອນ 5',
      month6: 'ເດືອນ 6',
      month7: 'ເດືອນ 7',
      month8: 'ເດືອນ 8',
      month9: 'ເດືອນ 9',
      month10: 'ເດືອນ 10',
      month11: 'ເດືອນ 11',
      month12: 'ເດືອນ 12',
      weeks: {
        sun: 'ອາທິດ',
        mon: 'ຈັນ',
        tue: 'ອັງຄານ',
        wed: 'ພຸດ',
        thu: 'ພະຫັດ',
        fri: 'ສຸກ',
        sat: 'ເສົາ'
      },
      months: {
        jan: 'ເດືອນມັງກອນ',
        feb: 'ເດືອນກຸມພາ',
        mar: 'ເດືອນມີນາ',
        apr: 'ເດືອນເມສາ',
        may: 'ເດືອນພຶດສະພາ',
        jun: 'ເດືອນມິຖຸນາ',
        jul: 'ເດືອນກໍລະກົດ',
        aug: 'ເດືອນສິງຫາ',
        sep: 'ເດືອນກັນຍາ',
        oct: 'ເດືອນຕຸລາ',
        nov: 'ເດືອນພະຈິກ',
        dec: 'ເດືອນທັນວາ'
      }
    },
    select: {
      loading: 'ກຳລັງໂຫລດ',
      noMatch: 'ບໍ່ມີຂໍ້ມູນທີ່ກົງກັບ',
      noData: 'ບໍ່ມີຂໍ້ມູນ',
      placeholder: 'ກະລຸນາກົດເລືອກ'
    },
    cascader: {
      noMatch: 'ບໍ່ມີຂໍ້ມູນທີ່ກົງເຕີມ',
      loading: 'ກຳລັງໂຫຼດ',
      placeholder: 'ກະລຸນາເລືອກ',
      noData: 'ບໍ່ມີຂໍ້ມູນ'
    },
    pagination: {
      goto: 'ຍົກເລີກ',
      pagesize: 'ລະຫັດ/ໜ້າ',
      total: 'ທັງໝົດ {total} ລາຍການ',
      pageClassifier: 'ໜ້າ',
      page: 'ໜ້າ',
      prev: 'ກັບຄືນ',
      next: 'ໜ້າຕໍ່ໄປ',
      currentPage: 'ໜ້ານີ້ {pager} ໜ້າ',
      prevPages: 'ໜ້າກ່ອນ {pager} ໜ້າ',
      nextPages: 'ໜ້າຕໍ່ໄປ {pager} ໜ້າ',
      deprecationWarning:
        'ທ່ານໃຊ້ວິທີການນີ້ມີຄວາມປົກກະຕິດເຫຼືອງທີ່ຖືກໃຊ້ຢູ່ແລ້ວ, ກະລຸນາເບິ່ງຂໍ້ມູນຂອງ el-pagination ຢູ່ໃນລາຍການຕົວຢ່າງຂອງເວັບໄຊ'
    },
    messagebox: {
      title: 'ແຈ້ງເຕືອນ',
      confirm: 'ຕົກລົງ',
      cancel: 'ຍົກເລີກ',
      error: 'ຂໍ້ມູນທີ່ປ້ອນບໍ່ຖືກຕ້ອງ!'
    },
    upload: {
      deleteTip: 'ກົດປ້ອນ delete ສາມາດລຶບໄດ້',
      delete: 'ລຶບ',
      preview: 'ເບິ່ງຮູບພາບ',
      continue: 'ຕໍ່ໄປທີ່ກ່ອນ'
    },
    table: {
      emptyText: 'ບໍ່ມີຂໍ້ມູນ',
      confirmFilter: 'ກອງກັບ',
      resetFilter: 'ລີ້ຊື່',
      clearFilter: 'ລຶບທັງໝົດ',
      sumText: 'ລວມ'
    },
    tree: { emptyText: 'ບໍ່ມີຂໍ້ມູນປະມານີການ' },
    transfer: {
      noMatch: 'ບໍ່ມີຂໍ້ມູນທີ່ກ່ຽວກັບ',
      noData: 'ບໍ່ມີຂໍ້ມູນ',
      titles: ['ລາຍການ 1', 'ລາຍການ 2'],
      filterPlaceholder: 'ກະລຸນາປ້ອນຂໍ້ຄວາມຄົບກັນ',
      noCheckedFormat: 'ທັງໝົດ {total} ລາຍການ',
      hasCheckedFormat: 'ເລືອກແລ້ວ {checked}/{total} ລາຍການ'
    },
    image: { error: 'ບໍ່ສາມາດໂຫລດໄດ້' },
    pageHeader: { title: 'ກັບຄືນ' },
    popconfirm: { confirmButtonText: 'ຕົກລົງ', cancelButtonText: 'ຍົກເລີກ' }
  }
}
